import { useCallback, useEffect, useRef, useState } from 'react'

export function useAsync<T>(loader: () => Promise<T>, deps: unknown[] = [], immediate = true) {
  const [data, setData] = useState<T | null>(null)
  const [loading, setLoading] = useState(immediate)
  const [error, setError] = useState<Error | null>(null)
  const mounted = useRef(true)

  useEffect(() => () => { mounted.current = false }, [])

  const run = useCallback(async () => {
    setLoading(true); setError(null)
    try {
      const value = await loader()
      if (mounted.current) setData(value)
      return value
    } catch (e) {
      const err = e instanceof Error ? e : new Error(String(e))
      if (mounted.current) setError(err)
      throw err
    } finally {
      if (mounted.current) setLoading(false)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)

  useEffect(() => { if (immediate) void run().catch(() => {}) }, [run, immediate])
  return { data, setData, loading, error, run }
}
